import type { Company, CompanyCrmInfo, TopCountries } from '../../domain/company';
import { BASE_API_URL, HttpClient } from '../../services/HttpClient';
import { isNumeric } from '../../services/string';

const BASE_URL = `${BASE_API_URL}/company`;
const BASE_COMPANIES_URL = `${BASE_API_URL}/companies`;

const MAX_COUNTRIES_COUNT = 252;

type CompanyApiParams = {
  linkedinId?: string;
  domain?: string;
};

const createCompanySearchParams = ({ domain, linkedinId }: CompanyApiParams) => {
  const searchParams = new URLSearchParams();
  if (domain) {
    searchParams.append('domain', domain);
  }
  if (linkedinId) {
    if (isNumeric(linkedinId)) {
      searchParams.append('numericLinkedinId', linkedinId);
    } else {
      searchParams.append('linkedinId', linkedinId);
    }
  }
  return searchParams.toString();
};

export const companyApi = {
  notifyCompanyView: async (domain: string, signal?: AbortSignal) =>
    HttpClient.post(`${BASE_URL}/notify-opened`, { domain }, { signal }),
  getCompanyInfo: async (params: CompanyApiParams, signal?: AbortSignal) =>
    HttpClient.getWithStatus<Company>(`${BASE_URL}/info?${createCompanySearchParams(params)}`, {
      signal,
    }),
  getCompaniesInfo: async (domains: string[], signal?: AbortSignal) =>
    HttpClient.postWithStatus<Company[]>(`${BASE_URL}/infos`, { domains }, { signal }),
  getTopCountries: async (params: CompanyApiParams, signal?: AbortSignal) =>
    HttpClient.get<TopCountries>(
      `${BASE_URL}/top-countries?${createCompanySearchParams(params)}&take=${MAX_COUNTRIES_COUNT}`,
      { signal }
    ),
  getCompanyCrmInfo: async (domain: string, signal?: AbortSignal) =>
    HttpClient.get<CompanyCrmInfo>(`${BASE_URL}/crm-info?domain=${domain}`, { signal }),
  reportEcommerceOverview: async (domain: string, signal?: AbortSignal) =>
    HttpClient.post<void>(`${BASE_COMPANIES_URL}/ecommerce?domain=${domain}`, undefined, { signal }),
  getEcommerceReportStatus: async (domain: string, signal?: AbortSignal) =>
    HttpClient.get<{ isEcommerceReported: boolean }>(
      `${BASE_COMPANIES_URL}/ecommerce/reported-status?domain=${domain}`,
      { signal }
    ),
};
